module.exports = __webpack_public_path__ + "images/iphone@2x-d11443.png";